<template>
  <v-dialog
    v-model="visible"
    hide-overlay
    transition="dialog-bottom-transition"
    max-width="500"
  >
    <v-form v-model="is_form_valid" ref="form">
      <v-card :loading="loading">
        <v-card-title>
          Buat Disposisi
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xl mt-5>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Catatan Disposisi"
                  placeholder="Ketik Catatan Diposisi"
                  v-model="form.note"
                  :rules="nonEmptyRule"
                  prepend-icon="mdi-information-outline"
                  rows="2"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="form.disposisi"
                  item-value="id"
                  item-text="name"
                  :rules="nonEmptyArray"
                  :items="$store.state.user.target_disposisi"
                  prepend-icon="mdi-account-multiple-check"
                  label="Tujuan Disposisi"
                  multiple
                  chips
                  deletable-chips
                  :menu-props="{ closeOnContentClick: true }"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.disposisi_at"
                      :rules="nonEmptyRule"
                      label="Tanggal Disposisi"
                      prepend-icon="mdi-calendar-range"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    locale="ID"
                    v-model="form.disposisi_at"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            v-if="!loading"
            @click="visible = false"
          >
            Batal
          </v-btn>
          <v-btn color="green darken-1" text :loading="loading" @click="submit">
            Kirim Disposisi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { disposisiSurat } from '@/services/surat'
import moment from 'moment'

const inititalForm = {
  id: '',
  note: '',
  disposisi: [],
  disposisi_at: moment().format('YYYY-MM-DD')
}

export default {
  data() {
    return {
      visible: false,
      nonEmptyRule: [v => !!v || 'tidak boleh kosong'],
      nonEmptyArray: [v => !!v.length || 'pilih tujuan disposisi'],
      is_form_valid: false,
      form: inititalForm,
      loading: false
    }
  },
  methods: {
    show(id) {
      this.form = {
        ...inititalForm,
        id: id
      }
      this.visible = true
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.loading = true
        const { data } = await disposisiSurat(this.form)
        console.log('Disposisi', data.data)
        this.visible = false
        this.$emit('success', data.data)
      } catch (error) {
        this.$emit('failed', error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
